import { InjectionToken } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../../../environments/environment';

export const OKTA_AUTH = new InjectionToken<OktaAuth>('OktaAuth', {
  providedIn: 'root',
  factory: () => new OktaAuth(environment.okta),
});
